/**
 * BeetleLogbookButton — animated 🐞 floating action button for instant screen-snapshot memos.
 * Positioned bottom-left — all other navigation FABs are bottom-right.
 * Visibility controlled by localStorage `logbook-beetle-visible`.
 * Always accessible from GearMenu regardless of visibility state.
 */

interface Props {
  /** Whether the beetle is visible (from localStorage / settings toggle) */
  visible: boolean;
  onClick: () => void;
}

export function BeetleLogbookButton({ visible, onClick }: Props) {
  if (!visible) return null;

  return (
    <button
      class="beetle-logbook-btn"
      onClick={onClick}
      title="Log a screen memo"
      type="button"
      aria-label="Open logbook"
    >
      🐜
    </button>
  );
}
